import React, { useEffect, useState } from "react";
import styles from "./caraousel.module.css";
import { Col, Row } from "react-bootstrap";
import greentickmark from "../../component/signup/assets/greenTickIcon.svg";

const CaraouselCard = ({
  uniqueId,
  selectedItem,
  setSelectedValue,
  selectedValue,
  selectedUserid,
  fixedwidth = false
}) => {
  const [greenCheck, setGreenCheck] = useState(false);

  var initial = selectedItem.fullName
    ? selectedItem.fullName.substring(0, 2).toUpperCase()
    : "?";
  var fulladdress =
    selectedItem.fullAddress +
    ", " +
    selectedItem.postalCode +
    ", " +
    selectedItem.city;

  const handleClick = () => {
    setSelectedValue(selectedItem);
  };

  useEffect(() => {
    setGreenCheck(selectedValue === selectedItem);
  }, [selectedValue, selectedItem]);

  useEffect(() => {
    if(selectedUserid && selectedItem.userAccountId === selectedUserid){
      setSelectedValue(selectedItem);
      setGreenCheck(true);
    }
  }, [selectedItem]);

  return (
    <div
      key={uniqueId}
      className={/*greenCheck ? styles.greenCard :*/ styles.mainCard}
      style={fixedwidth ? {width: "280px"} : {}}
      onClick={handleClick}
    >
              {/* <div className={styles.ribbon}>Approved</div> */}
      {greenCheck ? (
        <Col style={{ position: "relative" }}>
          <img className={styles.greentick} src={greentickmark} alt="" />
        </Col>
      ) : (
        ""
      )}
      <Row style={{minHeight: "120px"}}>
        <Col
         lg={3} md={3} xs={3}
          className={`d-flex ${styles.cardImageText}`}
        >
          <Row>
            <Col lg={12} className={styles.circleName}>
              {initial}
            </Col>
          </Row>
        </Col>
        <Col lg={9} md={9} sm={12} xs={9} className={styles.contentCol}>
            <p className={styles.nameHeading}>
              {selectedItem.fullName && selectedItem.fullName.length > 20
                ? `${selectedItem.fullName.slice(0, 20)}...`
                : selectedItem.fullName || "--"}
            </p>
            <p className={styles.textHeading}>
              {selectedItem.phone}
            </p>
            <p className={styles.textHeading}>
          Email:{" "}
          {selectedItem.email && selectedItem.email.length > 16
            ? `${selectedItem.email.slice(0, 16)}...`
            : selectedItem.email || "--"}
        </p>
        <p className={styles.textHeading} style={{marginBottom: "0px"}}>
          Address:{" "}
          {fulladdress && fulladdress.length > 38
            ? `${fulladdress.slice(0, 38)}...`
            : fulladdress || "--"}
        </p>
        </Col>
      </Row>
    </div>
  );
};
export default CaraouselCard;
